// import Swal from "sweetalert2";

import moment from "moment";

export default {
  methods: {
    $formatDatetime(value) {
      const date = moment(value);
      return date.isValid() ? date.format("DD/MM/YYYY HH:mm") : '-';
    },
    $formatDate(value) {
      const date = moment(value);
      return date.isValid() ? date.format("DD/MM/YYYY") : '-';
    },
    $formatTime(value) {
      const date = moment(value);
      return date.isValid() ? date.format("HH:mm") : '-';
    },
  },
};
